// extracted by mini-css-extract-plugin
module.exports = {"convertersWidgetWrapper":"styles_convertersWidgetWrapper__OUIqT","tabsStickyWrapper":"styles_tabsStickyWrapper__y7zVW","tabsWrapper":"styles_tabsWrapper__FsPJM"};